
export default {
    async get({endpoint, params}) {

        let config = {};
        if (params) config.params = params;
        return axios.get(endpoint, config);
    },
}
